import React from 'react';
import { ArtistSubscriptionFragment, DiscountTypeEnum } from '@minecraft.graphql-operations';
import Modal from '@minecraft.modal';
import { gqlSubscription } from '@minecraft.graphql-types';
import { PaywallLocation } from '../enums/PaywallLocation';
import { PlanType } from '../usePlans';
import { usePromotionModal } from './usePromotionModal';
import { SpecialDiscountModal } from './SpecialDiscountModal/SpecialDiscountModal';
import { ActiveCardlessTrialModal } from './CardlessTrialModals/ActiveCardlessTrialModal';
import { ExpiredCardlessTrialModal } from './CardlessTrialModals/ExpiredCardlessTrialModal';

type Props = {
  showBillingPopup: (data: { location?: PaywallLocation; discountType?: DiscountTypeEnum }) => void;
  setSelectedPlan: (plan: PlanType) => void;
  subscription: ArtistSubscriptionFragment | gqlSubscription;
  previousSubscription?: ArtistSubscriptionFragment | gqlSubscription;
  artistId: string | number;
  plans?: PlanType[];
};

export const PromotionModal = ({
  setSelectedPlan,
  showBillingPopup,
  subscription,
  artistId,
  plans,
  previousSubscription,
}: Props) => {
  const {
    isPromotionModalOpen,
    togglePromotionModal,
    closePromotionModal,
    discountedPlan,
    isOnCardlessTrialPlan,
    hasExpiredCardlessTrial,
  } = usePromotionModal({
    subscription,
    previousSubscription,
    artistId,
    plans,
  });

  return (
    <Modal
      title=""
      handleToggleClick={togglePromotionModal}
      isOpen={isPromotionModalOpen}
      isFooterHidden
      isHeaderHidden
      modalSize="small"
      data-testid="promotion-modal"
    >
      {discountedPlan && (
        <SpecialDiscountModal
          plans={plans}
          onCTAClick={() => {
            showBillingPopup({ location: PaywallLocation.DISCOUNT_MODAL });
            setSelectedPlan(discountedPlan);
            closePromotionModal();
          }}
          subscription={subscription}
        />
      )}
      {isOnCardlessTrialPlan && (
        <ActiveCardlessTrialModal
          plans={plans}
          subscription={subscription}
          onCTAClick={() => {
            showBillingPopup({ location: PaywallLocation.ACTIVE_CARDLESS_TRIAL_MODAL });
            closePromotionModal();
          }}
        />
      )}
      {hasExpiredCardlessTrial && (
        <ExpiredCardlessTrialModal
          plans={plans}
          subscription={subscription}
          onCTAClick={() => {
            showBillingPopup({ location: PaywallLocation.EXPIRED_CARDLESS_TRIAL_MODAL });
            closePromotionModal();
          }}
        />
      )}
    </Modal>
  );
};
